var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveroo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9796 2.00026L15.0564 10.8191L13.4816 3.38401L8.54427 4.43778L10.1183 11.8723L3 13.391L4.25728 19.3298L16.775 22L19.6376 15.5466L21 2.53023L15.979 2L15.9796 2.00051V2.00026ZM12.0241 14.7935C11.766 15.0308 11.4248 15.0089 11.0627 14.888C10.7013 14.7675 10.5406 14.3286 10.6776 13.7982C10.7796 13.4043 11.2598 13.3451 11.5 13.341C11.5913 13.3395 11.6811 13.358 11.764 13.3956C11.9338 13.4728 12.2215 13.6375 12.2799 13.8888C12.364 14.2512 12.283 14.5554 12.0249 14.7927H12.0244V14.7932L12.0241 14.7935ZM15.648 15.2028C15.4606 15.5296 14.9684 15.5729 14.4841 15.3351C14.1576 15.1744 14.1602 14.7657 14.1959 14.5165C14.2149 14.3806 14.2694 14.2523 14.354 14.1449C14.4706 13.9966 14.6652 13.8033 14.8901 13.7974C15.2558 13.7876 15.5705 13.9523 15.7482 14.2504C15.9268 14.5474 15.8375 14.8751 15.6496 15.2028H15.648Z",
    fill: "#00CCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveroo);
export default __webpack_public_path__ + "static/media/deliveroo.1a61a197b2fff8d1e0294babbd6f6a40.svg";
export { ForwardRef as ReactComponent };